import { onlineManager } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { queryKeys } from '@/queries/keys'
import { getPlanCancellationsQueryOptions } from '@/queries/query/plan'
import CancelBooking from '@/components/my-booking/CancelBooking'

export const Route = createFileRoute('/my-booking/$id/cancel/')({
  loader: ({ context }) => {
    if (onlineManager.isOnline() && !context.isRestoring) {
      return context.queryClient.ensureQueryData(
        getPlanCancellationsQueryOptions(),
      )
    }
    return context.queryClient.getQueryData(queryKeys.plan.cancellations())
  },
  component: RouteComponent,
})

function RouteComponent() {
  const bookingId = Route.useParams({
    select: (s) => s.id,
  })
  return <CancelBooking bookingId={bookingId} />
}
